import Layout from '@/layout';
var liveItem = function liveItem() {
  return import('@/views/pet/live/item');
};
var liveOrder = function liveOrder() {
  return import('@/views/pet/live/order');
};
var liveAuction = function liveAuction() {
  return import('@/views/pet/live/auction');
};
var liveContact = function liveContact() {
  return import('@/views/pet/live/contact');
};
var petProductForm = function petProductForm() {
  return import('@/views/pet/product/form');
};
var petClassify = function petClassify() {
  return import('@/views/pet/classify/index');
};
var auctionIndex = function auctionIndex() {
  return import('@/views/pet/auction/index');
};
var auctionList = function auctionList() {
  return import('@/views/pet/auction/list');
};
var auctionLog = function auctionLog() {
  return import('@/views/pet/auction/log');
};
var auctionDeposit = function auctionDeposit() {
  return import('@/views/pet/auction/deposit');
};
var auctionForm = function auctionForm() {
  return import('@/views/pet/auction/form');
};
var auctionStatistics = function auctionStatistics() {
  return import('@/views/pet/auction/statistics');
};
var petInfoIndex = function petInfoIndex() {
  return import('@/views/pet/info/index');
};
var petInfoForm = function petInfoForm() {
  return import('@/views/pet/info/form');
};
var petInfoStatistics = function petInfoStatistics() {
  return import('@/views/pet/info/statistics');
};
var petInfoTop = function petInfoTop() {
  return import('@/views/pet/info/top');
};
var petRecord = function petRecord() {
  return import('@/views/pet/record/index');
};
var rationIndex = function rationIndex() {
  return import('@/views/pet/ration/index');
};
var rationForm = function rationForm() {
  return import('@/views/pet/ration/form');
};
var petLabel = function petLabel() {
  return import('@/views/pet/label/cate');
};
var petUser = function petUser() {
  return import('@/views/pet/user/index');
};
var houseIndex = function houseIndex() {
  return import('@/views/pet/house/index');
};
var houseForm = function houseForm() {
  return import('@/views/pet/house/form');
};
var houseClassify = function houseClassify() {
  return import('@/views/pet/house/classify/index');
};
var houseLog = function houseLog() {
  return import('@/views/pet/house/log/index');
};
var houseSeedOrder = function houseSeedOrder() {
  return import('@/views/pet/house/seed_order/index');
};
var houseRuleLog = function houseRuleLog() {
  return import('@/views/pet/house/rule_log/index');
};
var houseRank = function houseRank() {
  return import('@/views/pet/house/rank/index');
};
var houseSeed = function houseSeed() {
  return import('@/views/pet/house/seed/index');
};
var houseTop = function houseTop() {
  return import('@/views/pet/house/top');
};
var voteIndex = function voteIndex() {
  return import('@/views/pet/vote/index');
};
var voteForm = function voteForm() {
  return import('@/views/pet/vote/form');
};
var voteUser = function voteUser() {
  return import('@/views/pet/vote/user');
};
var voteRewards = function voteRewards() {
  return import('@/views/pet/vote/rewards');
};
var voteSeed = function voteSeed() {
  return import('@/views/pet/vote/seed');
};
var voteHouse = function voteHouse() {
  return import('@/views/pet/vote/house');
};
var voteLog = function voteLog() {
  return import('@/views/pet/vote/log');
};
var chipIndex = function chipIndex() {
  return import('@/views/pet/chip/index');
};
var chipUser = function chipUser() {
  return import('@/views/pet/chip/user');
};
var chipVip = function chipVip() {
  return import('@/views/pet/chip/vip');
};
var chipBreeding = function chipBreeding() {
  return import('@/views/pet/chip/breeding');
};
var chipNameLog = function chipNameLog() {
  return import('@/views/pet/chip/name_log');
};
var chipOwner = function chipOwner() {
  return import('@/views/pet/chip/owner');
};
var chipFamily = function chipFamily() {
  return import('@/views/pet/chip/family');
};
var ParentView = function ParentView() {
  return import('@/layout/routerView/parent.vue');
};
var petRouter = {
  path: '/pet',
  component: Layout,
  redirect: '/pet/live/item',
  name: 'Pet',
  hidden: true,
  alwaysShow: true,
  meta: {
    title: '宠物经营',
    icon: 'clipboard'
  },
  children: [{
    path: 'live/item',
    name: 'MerchantPetLiveItemDirect',
    component: liveItem,
    meta: {
      title: '宠物列表'
    }
  }, {
    path: 'live/order',
    name: 'MerchantPetLiveOrderDirect',
    component: liveOrder,
    meta: {
      title: '宠物订单'
    }
  }, {
    path: 'live/auction',
    name: 'MerchantPetLiveAuctionDirect',
    component: liveAuction,
    meta: {
      title: '拍卖管理'
    }
  }, {
    path: 'live/contact',
    name: 'MerchantPetLiveContactDirect',
    component: liveContact,
    meta: {
      title: '联系方式配置'
    }
  }, {
    path: 'live_product',
    component: ParentView,
    redirect: '/pet/list',
    name: 'MerchantPetLiveProductGroup',
    meta: {
      title: '活体商品'
    },
    children: [{
      path: '/pet/list',
      alias: 'info/live/item',
      name: 'PetList',
      component: liveItem,
      meta: {
        title: '宠物列表'
      }
    }, {
      path: '/pet/pet_classify',
      alias: 'info/category',
      name: 'MerchantPetClassify',
      component: petClassify,
      meta: {
        title: '宠物分类'
      }
    }, {
      path: '/pet/add_product/:id?',
      name: 'MerchantPetProductAdd',
      component: petProductForm,
      hidden: true,
      meta: {
        title: '添加商品',
        noCache: true,
        activeMenu: '/pet/list'
      }
    }, {
      path: '/pet/edit/:id?',
      alias: 'info/live/auction',
      name: 'PetEdit',
      component: liveItem,
      hidden: true,
      meta: {
        title: '活体信息',
        noCache: true,
        activeMenu: '/pet/list'
      }
    }, {
      path: '/pet/order',
      alias: ['info/order', 'info/live/order'],
      name: 'PetOrder',
      component: liveOrder,
      meta: {
        title: '宠物订单'
      }
    }, {
      path: '/pet/info/live/contact',
      name: 'PetContactConfig',
      component: function component() {
        return import('@/views/pet/live/contact');
      },
      hidden: true,
      meta: {
        title: '联系方式配置',
        noCache: true,
        activeMenu: '/pet/list'
      }
    }]
  }, {
    path: 'store_auction',
    component: ParentView,
    redirect: '/pet/store_auction/index',
    name: 'MerchantPetAuctionGroup',
    meta: {
      title: '拍卖活动'
    },
    children: [{
      path: 'index',
      alias: 'auction/product',
      name: 'MerchantPetStoreAuction',
      component: auctionIndex,
      meta: {
        title: '拍卖商品'
      }
    }, {
      path: 'auction_list',
      alias: 'auction/list',
      name: 'MerchantPetAuctionList',
      component: auctionList,
      hidden: true,
      meta: {
        title: '拍卖列表',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'log',
      alias: 'auction/log',
      name: 'MerchantPetAuctionLog',
      component: auctionLog,
      hidden: true,
      meta: {
        title: '出价记录',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'deposit',
      alias: 'auction/deposit',
      name: 'MerchantPetAuctionDeposit',
      component: auctionDeposit,
      hidden: true,
      meta: {
        title: '保证金记录',
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'MerchantPetStoreAuctionCreate',
      component: auctionForm,
      hidden: true,
      meta: {
        title: '添加拍卖',
        noCache: true,
        activeMenu: '/pet/store_auction/index'
      }
    }, {
      path: 'statistics/:id?',
      name: 'MerchantPetStoreAuctionStatistics',
      component: auctionStatistics,
      hidden: true,
      meta: {
        title: '拍卖统计',
        noCache: true,
        activeMenu: '/pet/store_auction/auction_list'
      }
    }]
  }, {
    path: 'store_pet',
    component: ParentView,
    redirect: '/pet/store_pet/index',
    name: 'MerchantPetInfoGroup',
    meta: {
      title: '宠物信息'
    },
    children: [{
      path: 'index',
      alias: 'info/list',
      name: 'MerchantPetStorePet',
      component: petInfoIndex,
      meta: {
        title: '宠物信息列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'MerchantPetStorePetCreate',
      component: petInfoForm,
      hidden: true,
      meta: {
        title: '添加宠物信息',
        noCache: true,
        activeMenu: '/pet/store_pet/index'
      }
    }, {
      path: 'statistics/:id?',
      name: 'MerchantPetStorePetStatistics',
      component: petInfoStatistics,
      hidden: true,
      meta: {
        title: '宠物信息统计',
        noCache: true,
        activeMenu: '/pet/store_pet/index'
      }
    }, {
      path: 'top',
      alias: 'info/top',
      name: 'MerchantPetStorePetTop',
      component: petInfoTop,
      meta: {
        title: '宠物置顶'
      }
    }, {
      path: 'record',
      alias: 'info/coin/record',
      name: 'MerchantPetStorePetRecord',
      component: petRecord,
      meta: {
        title: '宠币记录'
      }
    }]
  }, {
    path: 'store_pet_ration',
    component: ParentView,
    redirect: '/pet/store_pet_ration/index',
    name: 'MerchantPetRationGroup',
    meta: {
      title: '口粮信息'
    },
    children: [{
      path: 'index',
      alias: 'info/ration',
      name: 'MerchantPetStorePetRation',
      component: rationIndex,
      meta: {
        title: '口粮列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'MerchantPetStorePetRationCreate',
      component: rationForm,
      hidden: true,
      meta: {
        title: '添加口粮信息',
        noCache: true,
        activeMenu: '/pet/store_pet_ration/index'
      }
    }, {
      path: '/pet/store_pet/label',
      alias: 'info/label',
      name: 'MerchantPetStorePetLabel',
      component: petLabel,
      meta: {
        title: '客户来源'
      }
    }, {
      path: '/pet/store_pet/userlist',
      alias: 'info/user',
      name: 'MerchantPetStorePetUserList',
      component: petUser,
      meta: {
        title: '派送员列表'
      }
    }]
  }, {
    path: 'store_pet_house',
    component: ParentView,
    redirect: '/pet/store_pet_house/index',
    name: 'MerchantPetHouseGroup',
    meta: {
      title: '宠舍管理'
    },
    children: [{
      path: 'index',
      alias: 'house/list',
      name: 'MerchantPetStorePetHouse',
      component: houseIndex,
      meta: {
        title: '宠舍列表'
      }
    }, {
      path: 'create/:id?/:copy?',
      name: 'MerchantPetStorePetHouseCreate',
      component: houseForm,
      hidden: true,
      meta: {
        title: '添加宠舍',
        noCache: true,
        activeMenu: '/pet/store_pet_house/index'
      }
    }, {
      path: '/pet/pet_house_classify',
      alias: 'house/category',
      name: 'MerchantPetHouseClassify',
      component: houseClassify,
      meta: {
        title: '宠舍分类'
      }
    }, {
      path: 'record/index/:id?',
      alias: 'house/log',
      name: 'MerchantPetStorePetHouseLog',
      component: houseLog,
      meta: {
        title: '咨询记录'
      }
    }, {
      path: 'seed_order',
      alias: 'house/order',
      name: 'MerchantPetStorePetHouseOrder',
      component: houseSeedOrder,
      meta: {
        title: '种公购买记录'
      }
    }, {
      path: 'rule_log',
      alias: 'house/rule-log',
      name: 'MerchantPetStorePetHouseRuleLog',
      component: houseRuleLog,
      meta: {
        title: '违规扣分记录'
      }
    }, {
      path: '/pet/store_pet_house_vote/index',
      alias: 'house/vote',
      name: 'MerchantPetStorePetHouseVote',
      component: voteIndex,
      meta: {
        title: '投票列表'
      }
    }, {
      path: '/pet/store_pet_house_vote/create/:id?/:copy?',
      name: 'MerchantPetStorePetHouseVoteCreate',
      component: voteForm,
      hidden: true,
      meta: {
        title: '添加投票',
        noCache: true,
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_user/:id?',
      alias: 'house/vote/user',
      name: 'MerchantPetVoteUser',
      component: voteUser,
      hidden: true,
      meta: {
        title: '报名列表',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_rewards/:id?',
      alias: 'house/vote/rewards',
      name: 'MerchantPetVoteRewards',
      component: voteRewards,
      hidden: true,
      meta: {
        title: '奖励列表',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_seed/:id?',
      alias: 'house/vote/seed',
      name: 'MerchantPetVoteSeed',
      component: voteSeed,
      hidden: true,
      meta: {
        title: '种公排行',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_house/:id?',
      alias: 'house/vote/house',
      name: 'MerchantPetVoteHouse',
      component: voteHouse,
      hidden: true,
      meta: {
        title: '宠舍排行',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/pet_vote_log/:id?',
      alias: 'house/vote/log',
      name: 'MerchantPetVoteLog',
      component: voteLog,
      hidden: true,
      meta: {
        title: '投票记录',
        activeMenu: '/pet/store_pet_house_vote/index'
      }
    }, {
      path: '/pet/store_pet_rank/index',
      alias: 'house/rank',
      name: 'MerchantPetStorePetHouseRank',
      component: houseRank,
      meta: {
        title: '排名列表'
      }
    }, {
      path: '/pet/pet_top_seed',
      alias: 'house/seed',
      name: 'MerchantPetTopSeed',
      component: houseSeed,
      meta: {
        title: '种公管理'
      }
    }, {
      path: '/pet/pet_top_house/:id?',
      alias: 'house/top',
      name: 'MerchantPetTopHouse',
      component: houseTop,
      hidden: true,
      meta: {
        title: '宠舍排行'
      }
    }]
  }, {
    path: 'chip',
    component: ParentView,
    redirect: '/pet/chip/index',
    name: 'MerchantPetChipGroup',
    meta: {
      title: '宠物芯片'
    },
    children: [{
      path: '/pet/chip/index',
      alias: 'chip/list',
      name: 'MerchantPetChip',
      component: chipIndex,
      meta: {
        title: '芯片管理'
      }
    }, {
      path: '/pet/chip/user',
      name: 'MerchantPetChipUser',
      component: chipUser,
      meta: {
        title: '会员管理'
      }
    }, {
      path: '/pet/chip/vip',
      name: 'MerchantPetChipVip',
      component: chipVip,
      meta: {
        title: '购买记录'
      }
    }, {
      path: '/pet/chip/breeding',
      alias: 'chip/mating',
      name: 'MerchantPetChipBreeding',
      component: chipBreeding,
      meta: {
        title: '配种管理',
        moduleKey: 'chipBreeding'
      }
    }, {
      path: '/pet/chip/name_log',
      alias: 'chip/name-log',
      name: 'MerchantPetChipNameLog',
      component: chipNameLog,
      meta: {
        title: '宠舍变更记录'
      }
    }, {
      path: '/pet/chip/owner',
      name: 'MerchantPetChipOwner',
      component: chipOwner,
      meta: {
        title: '宠主变更记录'
      }
    }, {
      path: '/pet/chip/family/:id?',
      alias: 'chip/family',
      name: 'MerchantPetChipFamily',
      component: chipFamily,
      hidden: true,
      meta: {
        title: 'DNA'
      }
    }]
  }]
};
export default petRouter;